$(document).ready(function() {
    $(document).on("click",".show-password",function() {
        $(".password-icon").addClass("active");
        $(this).removeClass("active");
        $(".password-input").attr("type","text");
    });
    $(document).on("click",".hide-password",function() {
        $(".password-icon").addClass("active");
        $(this).removeClass("active");
        $(".password-input").attr("type","password");
    });

    // document.querySelector('.recover-submit').addEventListener('click', function() {
    //   setTimeout(function() {
    //     var recoverpostinfo = document.getElementById('recover_post_info');
    //     recoverpostinfo.classList.remove('recover_hide');
    //     var recover_login_info = document.getElementById('login_info');
    //     recover_login_info.classList.add('recover_hide');
    //     console.log("DOne");
    //   }, 2500);
      
    //   //   var currentUrl = window.location.href;
    //   //   // window.location.href = currentUrl;
    //   //   window.location.hash = 'recover';
    //   //   document.getElementById('recover').style.display = 'block';
    //   //   document.getElementById('login').style.display = 'none';
    //   //   console.log(currentUrl);
      
    // });
    
    $(document).on("click","#main-content a.text-button",function(e) {
       e.preventDefault();
        const href = $(this).attr("href");
        console.log(href);
        $("#recover").hide();
        $("#login").hide();
         $(href).show();
    });
});


// document.addEventListener("DOMContentLoaded", function() {
//     // Select the form element
//     const form = document.querySelector(".recover_form");

//     // Add an event listener to the form for the submit event
//     form.addEventListener("submit", function(event) {
//         // Code to execute when the form is submitted
//         console.log("Form submitted!");
//         var recoverpostinfo = document.getElementById('recover_post_info');
//         recoverpostinfo.classList.remove('recover_hide');
//         var recover_login_info = document.getElementById('login_info');
//         recover_login_info.classList.add('recover_hide');
//         console.log("DOne");
//         // Optionally, you can submit the form programmatically if needed
//         // form.submit();
//     });
// });



// document.querySelector('.recover-submit').addEventListener('click', function() {
//     // Store state in session storage
//     sessionStorage.setItem('recover', 'true');
//   });

//   // On page load, check if we need to maintain the recover form
//   if (sessionStorage.getItem('recover') === 'true') {
//     // Remove the item from session storage
//     sessionStorage.removeItem('recover');
//     console.log("Form submitted!");
//     var recoverpostinfo = document.getElementById('recover_post_info');
//     recoverpostinfo.classList.remove('recover_hide');
//     var recover_login_info = document.getElementById('login_info');
//     recover_login_info.classList.add('recover_hide');
//     console.log("DOne");
//   }